import { ChildrenDOMType, transparentTag as css, } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { numberHeadingInfos } from './helper.js';
/** 开关自动编号时发出的事件名称 */
export const numberingEvtName = 'heading:numbering';
const styles = css `
  [data-exeditor-root] h1::before,
  [data-exeditor-root] h2::before,
  [data-exeditor-root] h3::before,
  [data-exeditor-root] h4::before,
  [data-exeditor-root] h5::before,
  [data-exeditor-root] h6::before {
    content: attr(data-numbering);
  }
`;
export class HeadingPlugin {
    constructor(opt = {}) {
        this.name = 'heading';
        this.renderToolbarItem = {
            heading: () => {
                const select = document.createElement('exeditor-toolbar-select');
                Object.assign(select, {
                    label: this.editor.t('标题'),
                    separateDropdown: true,
                }).appendChild(createIcon({
                    name: 'heading',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.headingIcon),
                }));
                this.opt.options.forEach((config) => {
                    const elt = document.createElement('exeditor-toolbar-option');
                    Object.assign(elt, {
                        slot: 'option',
                        value: config.value,
                        textContent: this.editor.t(config.label),
                        onclick: () => {
                            this.editor.focus();
                            if (config.value) {
                                this.level(+config.value);
                            }
                            else {
                                this.resetLevel();
                            }
                        },
                    });
                    select.appendChild(elt);
                });
                const setSelectProps = () => {
                    var _a;
                    select.value = String((_a = this.level()) !== null && _a !== void 0 ? _a : '');
                };
                setSelectProps();
                this.editor.on('idlechange', setSelectProps);
                return select;
            },
            headingNumbering: () => {
                const btn = document.createElement('exeditor-toolbar-button');
                btn.label = this.editor.t('标题自动编号');
                btn.appendChild(createIcon({
                    name: 'headingNumbering',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.headingNumberingIcon),
                }));
                btn.addEventListener('click', () => {
                    this.doNumbering(!btn.active);
                });
                this.editor.on(numberingEvtName, (enabled) => (btn.active = enabled));
                this.editor.on('idlechange', (e) => {
                    if (!e.docChanged || !btn.active) {
                        return;
                    }
                    this.doNumbering(true);
                });
                return btn;
            },
        };
        /** 获取或设置标题等级 */
        this.level = (level) => {
            if (typeof level === 'undefined') {
                return this.editor.selection().getNodeAttr(this.name, 'level');
            }
            const usedLevel = +level;
            this.editor
                .selection(true)
                .scrollIntoView()
                .convertToNode(this.name, { level: usedLevel });
            return usedLevel;
        };
        /** 去除标题等级，即重置为段落 */
        this.resetLevel = () => {
            this.editor.selection().convertToNode('paragraph');
        };
        /** 获取所有标题节点 */
        this.getAll = (levels = this.opt.levels) => {
            const ret = [];
            this.editor.doc.descendants((node, pos) => {
                if (node.type.name === this.name && levels.includes(node.attrs.level)) {
                    ret.push({ node, pos });
                    return false;
                }
            });
            return ret;
        };
        /** 更新所有标题的 numbering */
        this.doNumbering = (enabled) => {
            // 开启或开启状态下的更新
            if (enabled) {
                const infos = this.getAll(this.opt.numbering);
                const numberedInfos = numberHeadingInfos(infos, this.opt.numbering);
                numberedInfos.forEach(({ node, pos, numbering }) => {
                    this.patchNumberingIfNecessary(node, pos, numbering);
                });
            }
            else {
                // 关闭
                const allHeadingInfos = this.getAll();
                allHeadingInfos.forEach(({ node, pos }) => {
                    this.patchNumberingIfNecessary(node, pos, '');
                });
            }
            this.editor.emit(numberingEvtName, enabled);
        };
        this.opt = {
            levels: [1, 2, 3, 4, 5, 6],
            options: [
                { label: 'H1大标题', value: '1' },
                { label: 'H2中标题', value: '2' },
                { label: '正文', value: '' },
            ],
            numbering: [1, 2, 3, 4],
            ...opt,
        };
        this.spec = {
            type: 'node',
            childrenType: ChildrenDOMType.INLINE,
            matchSelector: this.opt.levels.map((l) => `h${l}`).join(','),
            attrs: {
                level: {
                    default: 1,
                    parse: (elt) => +elt.tagName.replace(/^h/i, ''),
                },
                numbering: {
                    default: '',
                    toDOMAttribute: (numbering) => numbering
                        ? {
                            'data-numbering': numbering,
                        }
                        : null,
                },
            },
            toDOM: ({ attrs }) => `h${attrs.level}`,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        const shortcuts = {
            'Mod-Alt-0': () => this.resetLevel(),
        };
        this.opt.options.forEach(({ value }) => {
            if (value) {
                shortcuts[`Mod-Alt-${value}`] = () => this.level(+value);
            }
        });
        return {
            styles,
            commands: {
                level: this.level,
                getAll: this.getAll,
                doNumbering: this.doNumbering,
            },
            shortcuts,
        };
    }
    // 更新某节点的 numbering，当且仅当其已有的 numbering 不同时
    patchNumberingIfNecessary(node, pos, numbering) {
        if (node.attrs.numbering !== numbering) {
            this.editor.noHistory().patchNodeAttr(pos, { numbering });
        }
    }
}
//# sourceMappingURL=index.js.map